var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCigaMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 50 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_833",
    "data-name": "\\uADF8\\uB8F9 833",
    transform: "translate(-4735 -980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_236",
    "data-name": "\\uC0AC\\uAC01\\uD615 236",
    transform: "translate(4735 980)",
    fill: "none",
    stroke: "current",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 56,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 54,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_237",
    "data-name": "\\uC0AC\\uAC01\\uD615 237",
    width: 30,
    height: 18,
    rx: 3,
    transform: "translate(4745 990)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_238",
    "data-name": "\\uC0AC\\uAC01\\uD615 238",
    transform: "translate(4745 1015)",
    fill: "none",
    stroke: "current",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 28,
    height: 8,
    rx: 4,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCigaMachine);
export default __webpack_public_path__ + "static/media/ciga_machine.70e813d4087fadeb7a8047f14eae5e5c.svg";
export { ForwardRef as ReactComponent };